var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { PageService } from '~/utils/page.service';
import { Prop, Emit, Watch } from 'vue-property-decorator';
import { TelCaseManageService } from '~/services/domain-service/tel-case-manage.service';
import DistributionPattern from "~/components/distribution-common/distribution-pattern.vue";
var TelConfirmDistribution = /** @class */ (function (_super) {
    __extends(TelConfirmDistribution, _super);
    function TelConfirmDistribution() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            distributeCategory: 'TO_COLLECTOR',
            commonFlag: 'YES',
            distributeMode: 'BY_CUSTOMIZE',
            distributeNumber: [],
        };
        _this.radio = '';
        _this.userDataSet = [];
        return _this;
    }
    TelConfirmDistribution.prototype.refreshList = function () { };
    TelConfirmDistribution.prototype.distributeModeChange = function (value) {
        var _this = this;
        this.telCaseManageService.reviewDistributeCase(this.model).subscribe(function (data) {
            _this.userDataSet = data.resDistModel;
            _this.model.analyseId = data.analyseId;
        });
    };
    TelConfirmDistribution.prototype.distributionDataChange = function (value) {
        var _this = this;
        if (!value)
            return;
        this.userDataSet = value.selectedUser;
        this.model.userIds = value.selectedUser.map(function (v) { return v.id; });
        this.model.caseIds = value.selectedCase.map(function (v) { return v.id; });
        this.telCaseManageService.reviewDistributeCase(this.model).subscribe(function (data) {
            _this.userDataSet = data.resDistModel;
        });
    };
    TelConfirmDistribution.prototype.refresh = function (distributionData, collectionType) {
        this.userDataSet = distributionData.userData;
        this.model.caseIds = distributionData.caseIds;
        this.model.collectionType = collectionType;
    };
    //取消
    TelConfirmDistribution.prototype.cancle = function () {
        //close
    };
    //上一步
    TelConfirmDistribution.prototype.back = function () { };
    //重置分配方式
    TelConfirmDistribution.prototype.reset = function () {
        this.model.distributeMode = 'BY_CUSTOMIZE';
    };
    //下一步
    TelConfirmDistribution.prototype.next = function () {
        var _this = this;
        this.model.outsourceIds = this.userDataSet.map(function (v) { return v.id; });
        this.model.distributeNumber = this.userDataSet.map(function (v) { return parseInt(v.num); });
        this.telCaseManageService.confirmDistributeCase(this.model).subscribe(function (data) {
            _this.$message.success('分配成功');
            _this.cancle();
            _this.refreshList();
        });
    };
    /**
     * 输入框最大值
     */
    TelConfirmDistribution.prototype.inputMax = function () {
        var max = this.model.caseIds.length;
        return max;
    };
    __decorate([
        Dependencies(PageService)
    ], TelConfirmDistribution.prototype, "pageService", void 0);
    __decorate([
        Dependencies(TelCaseManageService)
    ], TelConfirmDistribution.prototype, "telCaseManageService", void 0);
    __decorate([
        Prop({ required: true })
    ], TelConfirmDistribution.prototype, "distributionData", void 0);
    __decorate([
        Prop({ required: false, type: Boolean })
    ], TelConfirmDistribution.prototype, "again", void 0);
    __decorate([
        Emit('refreshList')
    ], TelConfirmDistribution.prototype, "refreshList", null);
    __decorate([
        Watch('model.distributeMode')
    ], TelConfirmDistribution.prototype, "distributeModeChange", null);
    __decorate([
        Watch('distributionData', { immediate: true })
    ], TelConfirmDistribution.prototype, "distributionDataChange", null);
    __decorate([
        Emit('close')
    ], TelConfirmDistribution.prototype, "cancle", null);
    __decorate([
        Emit('back')
    ], TelConfirmDistribution.prototype, "back", null);
    TelConfirmDistribution = __decorate([
        Component({
            components: {
                DistributionPattern: DistributionPattern
            },
        })
    ], TelConfirmDistribution);
    return TelConfirmDistribution;
}(Vue));
export default TelConfirmDistribution;
